<!-- <app-cps-search-panel></app-cps-search-panel> -->
<app-cps-tab-bar></app-cps-tab-bar>
<!-- No results label -->
<div class="no-resultPanel container-fluid" *ngIf="resultCount===0">
    <div class="no-result-found">{{ 'NoResults.header' | translate }}</div>
    <div class="yourSearchText"><span>{{ 'NoResults.tryAnotherSearch1' | translate }}"</span><span><b>{{searchTerm}}</b></span><span>"{{ 'NoResults.tryAnotherSearch2' | translate }}</span></div>
    <div *ngIf="didYouMean">
        <h4 class="did-you-mean">
            <span>{{ 'NoResults.didYouMean' | translate }}'</span>
            <a class="link-text no-margins" (click)="searchAgain(didYouMean)" [innerHTML]="didYouMean"></a>
            <span>'?</span>
        </h4>
    </div>
    <div class="trying-browsing-drug">
        <div>{{ 'NoResults.beforeShearchingAgain' | translate }}</div>
        <div>
            <ul>
                <li class="browsingOption">{{ 'NoResults.addOrRemoveKeyword' | translate }}</li>
                <li class="browsingOption">{{ 'NoResults.addToSomeWords' | translate }}</li>
                <li class="browsingOption">{{ 'NoResults.removeQuotes' | translate }}</li>
                <li class="browsingOption">{{ 'NoResults.clearSearchFilters' | translate }}</li>
                <li class="browsingOption">{{ 'NoResults.browsingContent' | translate }}
                    <ul>
                        <li class="browsingOption"><a class="drug-monographs" href='index/monographs'>{{ 'global-nav.cpsMono' | translate }}</a></li>
                        <li class="browsingOption" *ngIf="!limitedSubscription"><a class="drug-monographs" href='index/therapeuticchoices'>{{ 'global-nav.tc' | translate }}</a></li>
                        <li class="browsingOption" *ngIf="!limitedSubscription"><a class="drug-monographs" href='index/minorailments'>{{ 'global-nav.tcma' | translate }}</a></li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div>
  <!-- Search Results -->
  <div class="row resultPanel container-fluid">
    <div class="col-sm-12 col-md-2 col-lg-2 search-filter-container toc-wrapper active-toc" *ngIf="resultCount>0"
      [ngClass]="{'mobile-filter': mobileView}">
        <!-- Filter for search results (consider consolidating using a list of filters and ngfor)-->
        <span class="filtersHeader" (click)="toggleMobileSearchFilters()"
            [ngClass]="{'mobile-filter': mobileView}">
            {{ "ResultsPage.filters" | translate }}
        </span>
        <div class="search-filter-options"
            [ngClass]="{ 'hidden': mobileView && !isSearchFilterExpanded,
                         'mobile-filter': mobileView }">
            <div *ngFor="let searchFilter of searchFilterList">
                <div class="filter-count">
                    {{ searchFilter.resultCount }}
                </div>
                <span (click)="filterSelected(searchFilter)" class="row doctype-filter"
                    [ngClass]="{ 'selected': activeSearchFilter.docType == searchFilter.docType,
                                'unselectable': searchFilter.resultCount == 0}">
                    {{ searchFilter.labelKey | translate }}
                </span>
            </div>
        </div>
    </div>
    <div class="col-md-10 col-lg-10" *ngIf="resultCount>0">
        <div *ngIf="!isNpd" class="resultCount">
            {{activeSearchFilter.resultCount}} {{ 'ResultsPage.results' | translate }}
            <span class="resultText">{{searchTerm}}</span>
            <span *ngIf="activeSearchFilter.docType != ''">
                {{ 'Search.in' | translate }} {{ activeSearchFilter.labelKey | translate }}
            </span>
        </div>
        <div *ngIf="isNpd" class="resultCount">
            <span class="resultText">{{searchTerm}}</span>
        </div>
        <app-cps-results-group [data]="group" [filter]="activeSearchFilter.docType" *ngFor="let group of resultGroups"></app-cps-results-group>
    </div>
</div>

